import ColumnChart from './ColumnChart';

export default ColumnChart;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/slpPerFuel/components/columnChart/index.js